export default function stubFalse() {
  return false
}
